import { useOutletContext } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'

import FinancialWorkspacePayroll from 'modules/finance/components/FinancialWorkspacePayroll'
import WithPaywall from 'modules/finance/components/WithPaywall'

const FinancialWorkspacePayrollPage = () => {
  const { canSeeFinanceWorkspace, seePayrollLanding, canSeeFinanceWorkspacePayroll } =
    useOutletContext<{
      canSeeFinanceWorkspace: boolean
      seePayrollLanding: boolean
      canSeeFinanceWorkspacePayroll: boolean
    }>()

  return (
    <WithPaywall features={[Features.finance_workspace]}>
      {() => (
        <FinancialWorkspacePayroll
          authorized={canSeeFinanceWorkspace && canSeeFinanceWorkspacePayroll}
          seePayrollLanding={seePayrollLanding}
        />
      )}
    </WithPaywall>
  )
}

export default FinancialWorkspacePayrollPage
